import { render, staticRenderFns } from "./ExpandContact.vue?vue&type=template&id=38960ec8&scoped=true&"
import script from "./ExpandContact.vue?vue&type=script&lang=js&"
export * from "./ExpandContact.vue?vue&type=script&lang=js&"
import style0 from "./ExpandContact.vue?vue&type=style&index=0&id=38960ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38960ec8",
  null
  
)

export default component.exports